import CustomFilterSelect from '../../../shared/customFilterSelect';
import {httpInterceptor} from '../../../API/interceptor.jsx';
import {useEffect, useState} from 'react';
import './style.scss';
import {toast} from 'react-toastify';

function ModalNewUser({setModalNewUser, typeModal, setEditUser, item, userCreated}) {
    // STATES //

    const [isChecked, setIsChecked] = useState(true);

    const [formUser, setFormUser] = useState({
        email: item ? item.email : '',
        password: item ? item.password : '',
        fullName: item ? item.full_name : '',
        dni: item ? item.document : '',
        action: ''
    });

    const idTypes = [
        {
            name: 'Cedula',
            id: 'Cedula'
        },
        {
            name: 'Pasaporte',
            id: 'Pasaporte'
        }
    ]
    const roleTypes = [
        {
            name: 'Dinamizador',
            id: 1
        },
        {
            name: 'Administrador',
            id: 2
        }
    ];

    // METHODS //

    function submitUser() {
        if (!formUser.dni) {
            toast(`Número de identificación requerido`, {
                type: 'warning'
            });
            return;
        }

        if (!formUser.password) {
            toast(`Contraseña es requerido`, {
                type: 'warning'
            });
            return;
        }

        if (!formUser.fullName) {
            toast(`Nombre completo es requerido`, {
                type: 'warning'
            });
            return;
        }
        formUser.action = typeModal;
        formUser.active = isChecked
        httpInterceptor
            .post('users', formUser)
            .then(res => {
                if (res) {
                    if (res.success) {
                        toast('El usuario ha sido creado exitosamente', {
                            type: 'success'
                        });
                        userCreated(true)
                    } else {
                        toast('Ha ocurrido un problema, por favor intente nuevamente', {
                            type: 'error'
                        });
                    }
                    closeModals()
                }
            })
            .catch(error => {
                if (error?.response?.data?.message?.code === '23505') {
                    toast('El usuario ya existe', {
                        type: 'error'
                    });
                }
                if (error === 'MIN LENGTH') {
                    console.log('catch');
                    toast('La contraseña debe tener mínimo 8 caracteres', {
                        type: 'error'
                    });
                }
            });
    }

    function closeModals() {
        if (setEditUser) setEditUser(false);

        if (setModalNewUser) {
            setModalNewUser(false);
        }
    }

    function addInfo(name, value) {
        setFormUser({...formUser, [name]: value});
    }

    function changeUserState() {
        setIsChecked(!isChecked)
    }

    useEffect(() => {
       setIsChecked(item.active)
    }, [item]);

    return (
        <section className='main-createUser-container'>
            <p className='title'>
                {typeModal === 'create' ? 'CREAR NUEVO USUARIO' : 'EDITAR USUARIO'}{' '}
            </p>
            <section className='create-container'>
                {typeModal === 'edit' ? (
                    <div className='toggle-state-container'>
                        <p className='user-state'>{isChecked ? 'Activo' : 'No activo'}</p>

                        <label className='switch'>
                            <input onChange={changeUserState} type='checkbox' checked={isChecked}/>
                            <span className='slider round'></span>
                        </label>
                    </div>
                ) : null}
                <div></div>
                <div className='typeRol-container'>
                    <CustomFilterSelect
                        edit={item?.role?.name}
                        optionsList={roleTypes}
                        keyName={'role'}
                        addInfo={addInfo}
                        placeholder={'Rol'}
                    />
                </div>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Nombre completo'
                        type='text'
                        name='fullName'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.fullName}
                        className='input-form'
                    />
                </label>
                <div className='typeId-container'>
                    <CustomFilterSelect
                        edit={item?.document_type}
                        optionsList={idTypes}
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        addInfo={addInfo}
                        keyName='typeId'
                        placeholder={'Tipo de identificación'}
                    />
                </div>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Número de identificación'
                        type='number'
                        name='dni'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.dni}
                        className='input-form'
                        readOnly={typeModal === 'edit'}
                    />
                </label>

                <label className='email-container' htmlFor=''>
                    <input
                        placeholder='Correo electrónico'
                        type='text'
                        name='email'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        value={formUser.email}
                        className='input-form'
                    />
                </label>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Contraseña'
                        value={formUser.password}
                        type='text'
                        onChange={e => addInfo(e.target.name, e.target.value)}
                        name='password'
                        className='input-form'
                    />
                </label>
                <div className='buttons-container'>
                    <button
                        onClick={() => submitUser()}
                        className='blue-site-button create'>
                        {typeModal === 'create'? 'CREAR': 'ACTUALIZAR'}
                    </button>
                    <button onClick={closeModals} className='button-white-border-blue'>
                        CANCELAR
                    </button>
                </div>
            </section>
        </section>
    );
}

export default ModalNewUser;
